<template>
	<div>
		<div id="indexRightChart" style="width: 5rem; height: 2.6rem;"></div>
	</div>
</template>

<script>
	import echartMixins from "@/utils/resizeMixins";
	export default {
		data() {
			return {
				chart: null,
				energyTotal: [],
				dateList: [],
			};
		},
		mixins: [echartMixins],
		props: ['weekEnergyData'],
		watch: {
			'weekEnergyData': {
				handler() {
					for(let item of this.weekEnergyData){
						this.energyTotal.push(item.air + item.pump + item.cooling)
						this.dateList.push(item.date.substr(5, 5))
					}
					this.draw();
				},
				deep: true
			}
		},
		mounted() {
			
		},
		methods: {
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("indexRightChart")
				);

				let option = {
					tooltip: {
						trigger: 'item'
					},
					grid: {
						left: 60,
					},
					title: {
						text: '近7日用能',
						left: 'center',
						top: 20,
						textStyle: {
							color: '#fff'
						}
					},
					xAxis: {
						type: "category",
						data: this.dateList,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisTick: {
							show: false
						}
					},
					yAxis: {
						type: "value",
						name: "KWH",
						nameTextStyle: {
							color: '#fff'
						},
						axisLabel: {
							formatter: function(value) {
								if (value >= 1000) {
									value = value / 1000 + "k";
								} else if (value < 1000) {
									value;
								}
								return value;
							},
							textStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#323232',
								type: "dashed"
							}
						}
					},
					series: [{
						type: "line",
						smooth: true,
						data: this.energyTotal,
						itemStyle: {
							normal: {
								color: '#396EB0', //折点颜色
								lineStyle: {
									color: '#396EB0' //折线颜色
								}
							}
						}
					}, ],
				};
				this.chart.setOption(option);
			},
			// refresh(data) {
			// 	let option = this.chart.getOption();
			// 	var showList = new Array();
			// 	var hiddenList = new Array();
			// 	var wordList = new Array();
			// 	// let coutSum = data[0];
			// 	let temp = 0;
			// 	for (let index = 0; index < data.length; index++) {
			// 		const element = data[index];
			// 		wordList.push(element.X0);
			// 		showList.push(element.COUNT);
			// 		if (index > 1) {
			// 			temp += data[index - 1].COUNT;
			// 		}
			// 		hiddenList.push(temp);
			// 	}

			// 	option.xAxis[0].data = wordList;
			// 	option.series[0].data = hiddenList;
			// 	option.series[1].data = showList;

			// 	// console.log(wordLisst)
			// 	// console.log(hiddenList)
			// 	// console.log(showList)
			// 	this.chart.setOption(option);

			// },
		},

		destroyed() {
			window.onresize = null;
		},
	};
</script>

<style lang="scss" scoped>
</style>
